import React from "react";
import { ScitusLogo } from "./ScitusLogo";

const COLS = [
    {
        title: "Products",
        items: [
            { label: "Mativex — Analytics", href: "/products/mativex" },
            { label: "Vexen — Operations", href: "/products/vexen" },
            { label: "Karya — HR", href: "/products/karya" },
            { label: "Vyaahar — Finance", href: "/products/vyaahar" },
            { label: "Attestra — Signing", href: "/products/attestra" },
            { label: "Acrium — Project & Cost", href: "/products/acrium" },
            { label: "Kretara — Procurement", href: "/products/kretara" },
        ],
    },
    {
        title: "Industries",
        items: [
            { label: "Retail", href: "/industries/retail" },
            { label: "Real Estate", href: "/industries/real-estate" },
            { label: "Healthcare", href: "/industries/healthcare" },
            { label: "Manufacturing", href: "/industries/manufacturing" },
            { label: "Services", href: "/industries/services" },
        ],
    },
    {
        title: "Resources",
        items: [
            { label: "Customer stories", href: "/stories" },
            { label: "Insights", href: "/blog" },
            { label: "Changelog", href: "/changelog" },
            { label: "Compare", href: "/compare" },
            { label: "Integrations", href: "/integrations" },
        ],
    },
    {
        title: "Company",
        items: [
            { label: "About", href: "/about" },
            { label: "Pricing", href: "/pricing" },
            { label: "Contact", href: "/contact" },
            { label: "Privacy", href: "/privacy" },
            { label: "Terms", href: "/terms" },
            { label: "DPA", href: "/dpa" },
        ],
    },
];

export const Footer = () => {
    return (
        <footer className="footer" data-testid="footer">
            <div className="container">
                <div className="footer-grid">
                    <div>
                        <ScitusLogo height={28} />
                        <p className="muted" style={{ marginTop: 16, maxWidth: 320, fontSize: "0.92rem" }}>
                            Built individually. Better together. Standalone operator products that share one platform — pick what you need.
                        </p>
                        <p className="muted" style={{ marginTop: 14, fontSize: "0.85rem" }} data-testid="footer-contact-email">
                            hello@scitus.ai
                        </p>
                    </div>
                    {COLS.map((c) => (
                        <div className="footer-col" key={c.title}>
                            <h4>{c.title}</h4>
                            <ul>
                                {c.items.map((it) => (
                                    <li key={it.label}>
                                        <a href={it.href} data-testid={`footer-link-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{it.label}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
                <div className="footer-bottom">
                    <span data-testid="footer-copyright">© 2026 Vyastics Technologies Pvt Ltd. All rights reserved.</span>
                    <span>Made with care · Available worldwide</span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
